import { useMemo } from 'react';
import { useIsFeatureEnabled } from 'src/hooks';
import { FeatureFlag } from 'src/types';

const FORM_TYPE_FILTER_ALL = 'All';
const FORM_TYPE_FILTER_SPEAK_UP = 'Speak Up';
const FORM_TYPE_FILTER_CONFLICT_OF_INTEREST = 'Conflict of Interest';

export const FORM_TYPE_ID_TO_URL_SLUG: Record<string, string> = {
  'speak-up': 'speak-up',
  disclosure: 'disclosure',
};

export interface FormManagementFeatureFlags {
  speakUpEnabled: boolean;
  coiEnabled: boolean;
  showCreateFormModal: boolean;
  directFormTypeSlug: string | null;
  formTypeFilterOptions: string[];
}

export function useFormManagementFeatureFlags(): FormManagementFeatureFlags {
  const speakUpEnabled = useIsFeatureEnabled(FeatureFlag.DYNAMIC_QUESTIONS_V1);
  const coiEnabled = useIsFeatureEnabled(FeatureFlag.CONFLICT_OF_INTEREST);

  return useMemo(() => {
    const showCreateFormModal = speakUpEnabled && coiEnabled;
    let directFormTypeSlug: string | null = null;
    if (speakUpEnabled && !coiEnabled) directFormTypeSlug = 'speak-up';
    if (!speakUpEnabled && coiEnabled) directFormTypeSlug = 'disclosure';

    const formTypeFilterOptions = [
      FORM_TYPE_FILTER_ALL,
      ...(speakUpEnabled ? [FORM_TYPE_FILTER_SPEAK_UP] : []),
      ...(coiEnabled ? [FORM_TYPE_FILTER_CONFLICT_OF_INTEREST] : []),
    ];

    return {
      speakUpEnabled,
      coiEnabled,
      showCreateFormModal,
      directFormTypeSlug,
      formTypeFilterOptions,
    };
  }, [speakUpEnabled, coiEnabled]);
}
